import { render, staticRenderFns } from "./ModalModalFotoIBPAdicionar.vue?vue&type=template&id=ae9c321c"
import script from "./ModalModalFotoIBPAdicionar.vue?vue&type=script&lang=js"
export * from "./ModalModalFotoIBPAdicionar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports